import { Tabs } from "antd";
import React, { useState } from "react";
import InsideHeader from "../../../components/InsideHeader";
import PayslipReport from "./PayslipReport";
import { useDispatch } from "react-redux";
import {
  setRefetch,
  setRefetchKey,
} from "../../../features/folder/folderSlice";
import P9Report from "./P9Report";

function PayslipList() {
  const dispatch = useDispatch();
  const [active, setactive] = useState("1");
  async function refetching(activeKey) {
    setactive(activeKey)
  }

  const tabConfigurations = [
    {
      label: (
        <span className="flex items-center">
          <span className="">Download Payslip</span>
        </span>
      ),
      key: "1",
      children: <PayslipReport active={active} setactive={setactive} />,
    },

    {
      label: (
        <span className="flex items-center">
          <span className="">Download P9</span>
        </span>
      ),
      key: "2",
      children: <P9Report active={active} setactive={setactive} />,
    },
  ];

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Generate Payslip Reports"
        subtitle="Have a view of all your payslip reports here"
        back={false}
      />
    
      <div className="h-auto  mt-[1rem] w-full  lg:px-10 px-3 bg-white rounded-[10px]">
        <Tabs
          items={tabConfigurations}
          defaultActiveKey="1"
          activeKey={active}
          onChange={refetching}
          className="activity-tab activity-tab-wrap activity-bar"
        />
      </div> 
    </div>
  );
}

export default PayslipList;
